<template>
  <div id="app">
    <search-list></search-list>
  </div>
</template>

<script>
import SearchList from "./components/search-list";
export default {
  name: "App",
  components: {
    SearchList
  }
};
</script>

<style>
#app {
  font-family: MicrosoftYaHei, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
* {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
}
a,
a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: inherit;
}
</style>
